import { create } from 'zustand';
type PopupState = {
  show: boolean;
  type: 'success' | 'error' | 'warn';
  message: string;
};

type PopupActions = {
  showPopup: (type: 'success' | 'error' | 'warn', message: string) => void;
  closePopup: () => void;
};

export const usePopupStore = create<PopupState & PopupActions>((set) => ({
  show: false,
  type: 'success',
  message: '',
  showPopup: (type, message) => {
    set({ show: true, type, message });
  },
  closePopup: () => {
    set({ show: false, message: '' });
  },
}));
